import { useState } from 'react';

const faqs = [
  {
    q: 'What file formats do you accept?',
    a: 'We accept all common video formats including MP4, MOV, AVI, MKV, and more. Just upload your raw files to Google Drive or Dropbox and share the link — we handle the rest.',
  },
  {
    q: 'How do I share my footage with you?',
    a: 'Upload your raw clips to a Google Drive or Dropbox folder, set sharing to "Anyone with the link can view," and paste the link in our inquiry form. It\'s that simple.',
  },
  {
    q: 'How long does editing take?',
    a: 'Most short-form videos are delivered within 48 hours. For larger batches or complex projects, we\'ll give you a clear timeline upfront. Rush delivery is available on request.',
  },
  {
    q: 'Do you provide the music or do I need to supply it?',
    a: 'We source licensed, royalty-free music that fits your brand and content style. If you have a specific track in mind, just let us know and we\'ll use it.',
  },
  {
    q: 'How many revisions are included?',
    a: 'Starter packages include 1 round of revisions, Growth includes 2 rounds per video, and Pro includes unlimited revisions. We work until you\'re completely satisfied.',
  },
  {
    q: 'Can you edit videos for multiple platforms at once?',
    a: 'Absolutely. We can deliver the same video optimized for different aspect ratios — vertical for Reels/TikTok, square for Instagram feed, and horizontal for YouTube.',
  },
];

export default function FAQ() {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section className="py-24 bg-white">
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 bg-[#1E3A8A]/10 text-[#1E3A8A] text-xs font-semibold rounded-full mb-4 tracking-widest uppercase">
            FAQ
          </span>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Common Questions</h2>
          <p className="text-gray-600 text-base">Everything you need to know before submitting your first project.</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="border border-gray-200 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer hover:bg-gray-50 transition-colors"
              >
                <span className="font-semibold text-gray-900 text-sm pr-4">{faq.q}</span>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className={`ri-${open === i ? 'subtract' : 'add'}-line text-[#1E3A8A] text-lg`}></i>
                </div>
              </button>
              {open === i && (
                <div className="px-6 pb-5">
                  <p className="text-gray-600 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
